export default __webpack_public_path__ + "images/0x9b8df6e244526ab5f6e6400d331db28c8fdddb55.png";